var React = require('react');
var ReactNative = require('react-native');

var {
  AppRegistry,
  View,
  StyleSheet,
  Animated,
  Image,
} = ReactNative;

var ReUpText = require('./ReUpText');

var Ticker = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      style : {},
      appManager : null,
      animated : true,
      points : 0,
      isTitle : false,
      renderText : function(input){return input},
    }
  },

  getInitialState : function()
  {
    return {
      layout : this.props.initialLayout,
      points : new Animated.Value(0),
      pointsVal : 0,
    }
  },

  componentDidMount : function()
  {
    var thisThing = this;
    this.state.points.addListener(({value}) =>
    {
      thisThing.setState({pointsVal:value})
    });

    setTimeout(()=>
    {
      thisThing._hasDoneFirstSet = true;
      thisThing.setPoints(thisThing.props.points);
    }, 500)
  },

  componentWillReceiveProps : function(newProps)
  {
    if( typeof newProps.points !== 'undefined' ) this.setPoints(newProps.points);
  },

  _hasDoneFirstSet : false,
  setPoints : function(newPoints)
  {
    if( !this._hasDoneFirstSet ) return;

    Animated.spring(
      this.state.points,
      {
        toValue: newPoints,
        tension: 8,
        friction: 9,
      },
    ).start();
  },

  render : function()
  {
    var appManager = this.props.appManager;
    return (
      <ReUpText appManager={appManager} style={this.props.style} isTitle={this.props.isTitle}>
      {this.props.renderText(this.state.pointsVal)}
      </ReUpText>
    )
  }
})

module.exports = Ticker;



// WEBPACK FOOTER //
// ./src/PointsTicker.js